import { makeAutoObservable, observable, action, runInAction } from "mobx";
import agent from "../api/agent";
import { RootStore } from "./rootStore";
import { showError } from "../util/errorTypeEnumsOptions";
import {
  IBrokerFilter,
  IDocumentReportBrokerResult,
  IDocumentReportSudoResult,
  IDocumentReportTenantResult,
  ISettlementFilter,
  ITenantFilter,
} from "../models/report";
import { IList } from "../models/listOfValours";
import { getDateFormatDDMMAAAA, getFilterFormat } from "../util/dateOptions";
import { history } from "../..";

export default class ReportStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
  }

  @observable loadDataSettlement = false;
  @observable btFilterSettlement = false;
  @observable acordionSettlementFilter = false;
  @observable settlementFilter: ISettlementFilter = {
    brokerId: "",
    dateFrom: null,
    dateTo: null,
  };
  @observable documentsSettlement: IDocumentReportSudoResult[] = [];
  @observable countSettlement = 0;

  @observable loadDataBroker = false;
  @observable btFilterBroker = false;
  @observable acordionBrokerFilter = false;
  @observable brokerFilter: IBrokerFilter = {
    brokerId: "",
    tenantId: "",
    dateFrom: null,
    dateTo: null,
  };
  @observable documentsBroker: IDocumentReportBrokerResult[] = [];
  @observable countBroker = 0;

  @observable loadDataTenant = false;
  @observable btFilterTenant = false;
  @observable acordionTenantFilter = false;
  @observable tenantFilter: ITenantFilter = {
    brokerId: "",
    tenantId: "",
    dateFrom: null,
    dateTo: null,
  };
  @observable documentsTenant: IDocumentReportTenantResult[] = [];
  @observable countTenant = 0;

  @observable brokersAutocomplete: IList[] = [
    { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
  ];

  @observable tenantsAutocomplete: IList[] = [
    { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
  ];

  @action clearBrokerFilter = () =>{
    this.loadDataBroker = false;
    this.btFilterBroker = false;
    this.acordionBrokerFilter = false;
    this.brokerFilter = {
      brokerId: "",
      tenantId: "",
      dateFrom: null,
      dateTo: null,
    };
    this.documentsBroker = [];
    this.countBroker = 0;
  }

  @action clearFilters = () => {
    this.loadDataSettlement = false;
    this.btFilterSettlement = false;
    this.acordionSettlementFilter = false;
    this.settlementFilter = {
      brokerId: "",
      dateFrom: null,
      dateTo: null,
    };
    this.documentsSettlement = [];
    this.countSettlement = 0;
    this.loadDataBroker = false;
    this.btFilterBroker = false;
    this.acordionBrokerFilter = false;
    this.brokerFilter = {
      brokerId: "",
      tenantId: "",
      dateFrom: null,
      dateTo: null,
    };
    this.documentsBroker = [];
    this.countBroker = 0;
    this.loadDataTenant = false;
    this.btFilterTenant = false;
    this.acordionTenantFilter = false;
    this.tenantFilter = {
      brokerId: "",
      tenantId: "",
      dateFrom: null,
      dateTo: null,
    };
    this.documentsTenant = [];
    this.countTenant = 0;
    this.brokersAutocomplete = [
      { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
    ];
    this.tenantsAutocomplete = [
      { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
    ];
  };

  @action setSettlementFilter = (filter: ISettlementFilter) => {
    this.settlementFilter = filter;
    this.getDocumentsSettlement();
  };

  @action getSettlementFilter = () => {
    return {
      brokerId: this.settlementFilter.brokerId,
      dateFrom: getFilterFormat(this.settlementFilter.dateFrom),
      dateTo: getFilterFormat(this.settlementFilter.dateTo),
    };
  };

  @action setBrokerFilter = (filter: IBrokerFilter) => {
    this.brokerFilter = filter;
    this.getDocumentsBroker();
  };

  @action getBrokerFilter = () => {
    return {
      brokerId: this.brokerFilter.brokerId,
      tenantId: this.brokerFilter.tenantId,
      dateFrom: getFilterFormat(this.brokerFilter.dateFrom),
      dateTo: getFilterFormat(this.brokerFilter.dateTo),
    };
  };

  @action setTenantFilter = (filter: ITenantFilter) => {
    this.tenantFilter = filter;
    this.getDocumentsTenant();
  };

  @action getTenantFilter = () => {
    return {
      brokerId: this.tenantFilter.brokerId,
      tenantId: this.tenantFilter.tenantId,
      dateFrom: getFilterFormat(this.tenantFilter.dateFrom),
      dateTo: getFilterFormat(this.tenantFilter.dateTo),
    };
  };

  @action detailSettlement = (brokerName: string, brokerId: string) => {
    this.clearBrokerFilter();
    this.getBrokersAutocomplete(brokerName);
    this.brokerFilter.brokerId = brokerId;
    this.brokerFilter.dateFrom = this.settlementFilter.dateFrom;
    this.brokerFilter.dateTo = this.settlementFilter.dateTo;
    history.push("/home/Report/DashboardReportBroker");
  };

  @action changeStatebtSettlementFilter = () => {
    this.btFilterSettlement = !this.btFilterSettlement;
  };

  @action changeStateAcordionSettlement = () => {
    this.acordionSettlementFilter = !this.acordionSettlementFilter;
  };

  @action changeStatebtBrokerFilter = () => {
    this.btFilterBroker = !this.btFilterBroker;
  };

  @action changeStateAcordionBroker = () => {
    this.acordionBrokerFilter = !this.acordionBrokerFilter;
  };

  @action changeStatebtTenantFilter = () => {
    this.btFilterTenant = !this.btFilterTenant;
  };

  @action changeStateAcordionTenant = () => {
    this.acordionTenantFilter = !this.acordionTenantFilter;
  };

  @action getDocumentsBroker = async () => {
    this.changeStatebtBrokerFilter();
    try {
      const list = await agent.Report.getDocumentReportBrokerByFilter(
        this.getBrokerFilter()
      );
      runInAction(() => {
        this.countBroker = 0;
        list.map(x=>this.countBroker+=x.numberOfDocuments);
        this.documentsBroker = list;
      });
    } catch (error) {
      runInAction(() => {
        this.documentsBroker = [];
      });
      showError(error);
    }
    this.changeStatebtBrokerFilter();
    runInAction(() => {
      this.loadDataBroker = true;
      this.acordionBrokerFilter = false;
    });
  };

  @action getDocumentsTenant = async () => {
    this.changeStatebtTenantFilter();
    try {
      const list = await agent.Report.getDocumentReportTenantByFilter(
        this.getTenantFilter()
      );
      runInAction(() => {
        this.countTenant=0;
        list.map(x=>this.countTenant+=x.numberOfDocuments);
        this.documentsTenant = list;
      });
    } catch (error) {
      runInAction(() => {
        this.documentsTenant = [];
      });
      showError(error);
    }
    this.changeStatebtTenantFilter();
    runInAction(() => {
      this.loadDataTenant = true;
      this.acordionTenantFilter = false;
    });
  };

  @action getDocumentsSettlement = async () => {
    this.changeStatebtSettlementFilter();
    try {
      const list = await agent.Report.getDocumentReportSudoByFilter(
        this.getSettlementFilter()
      );
      runInAction(() => {
        this.countSettlement=0;
        list.map(x=>this.countSettlement+=x.totalPrice);
        this.documentsSettlement = list;
      });
    } catch (error) {
      runInAction(() => {
        this.documentsSettlement = [];
      });
      showError(error);
    }
    this.changeStatebtSettlementFilter();
    runInAction(() => {
      this.loadDataSettlement = true;
      this.acordionSettlementFilter = false;
    });
  };

  @action getBrokersAutocomplete = async (search: string) => {
    if (search === "") {
      runInAction(() => {
        this.brokersAutocomplete = [
          { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
        ];
      });
    }
    try {
      const check = await agent.Report.getBrokersAutocomplete(search);
      runInAction(() => {
        this.brokersAutocomplete = [
          { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
        ];
        check.map((b) => {
          this.brokersAutocomplete.push({
            key: `${b.id}${b.companyID}`,
            text: `${b.companyID}-${b.registrationName}`,
            value: `${b.id}`,
          });
        });
      });
    } catch (error) {}
  };

  @action getTenantsAutocomplete = async (search: string) => {
    if (search === "") {
      runInAction(() => {
        this.tenantsAutocomplete = [
          { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
        ];
      });
    }
    try {
      const check = await agent.Report.getTenantsAutocomplete(search);
      runInAction(() => {
        this.tenantsAutocomplete = [
          { key: `sinFiltro`, text: `Sin Filtro`, value: "" },
        ];
        check.map((b) => {
          this.tenantsAutocomplete.push({
            key: `${b.id}${b.companyID}`,
            text: `${b.companyID}-${b.registrationName}`,
            value: `${b.id}`,
          });
        });
      });
    } catch (error) {}
  };

  @action getSettlementFilterInfo = () => {
    let info = ``;

    if (
      this.settlementFilter.brokerId !== "" &&
      this.settlementFilter.brokerId !== undefined
    ) {
      info += `<div class="column filterinfoitem">Agente: ${
        this.brokersAutocomplete.find(
          (x) => x.value === this.settlementFilter.brokerId
        ).text
      }</div>`;
    }

    if (
      (this.settlementFilter.dateFrom || this.settlementFilter.dateTo) !== null
    ) {
      info += `<div class="column filterinfoitem">Fecha comprobante: `;
      if (this.settlementFilter.dateFrom !== null) {
        info += `desde: ${getDateFormatDDMMAAAA(
          this.settlementFilter.dateFrom.toString()
        )} `;
      }
      if (this.settlementFilter.dateTo !== null) {
        info += `hasta: ${getDateFormatDDMMAAAA(
          this.settlementFilter.dateTo.toString()
        )}`;
      }
      info += `</div>`;
    }
    if (info !== "") {
      info =
        '<div class="ui three column grid filterinfocontainer"><div class="row filterinforow">' +
        info +
        `</div></div>`;
    }
    return info;
  };

  @action getBrokerFilterInfo = () => {
    let info = ``;

    if (
      this.brokerFilter.brokerId !== "" &&
      this.brokerFilter.brokerId !== undefined
    ) {
      info += `<div class="column filterinfoitem">Agente: ${
        this.brokersAutocomplete.find(
          (x) => x.value === this.brokerFilter.brokerId
        ).text
      }</div>`;
    }

    if (
      this.brokerFilter.tenantId !== "" &&
      this.brokerFilter.tenantId !== undefined
    ) {
      info += `<div class="column filterinfoitem">Cliente: ${
        this.tenantsAutocomplete.find(
          (x) => x.value === this.brokerFilter.tenantId
        ).text
      }</div>`;
    }

    if ((this.brokerFilter.dateFrom || this.brokerFilter.dateTo) !== null) {
      info += `<div class="column filterinfoitem">Fecha comprobante: `;
      if (this.brokerFilter.dateFrom !== null) {
        info += `desde: ${getDateFormatDDMMAAAA(
          this.brokerFilter.dateFrom.toString()
        )} `;
      }
      if (this.brokerFilter.dateTo !== null) {
        info += `hasta: ${getDateFormatDDMMAAAA(
          this.brokerFilter.dateTo.toString()
        )}`;
      }
      info += `</div>`;
    }
    if (info !== "") {
      info =
        '<div class="ui three column grid filterinfocontainer"><div class="row filterinforow">' +
        info +
        `</div></div>`;
    }
    return info;
  };

  @action getTenantFilterInfo = () => {
    let info = ``;

    if (
      this.tenantFilter.brokerId !== "" &&
      this.tenantFilter.brokerId !== undefined
    ) {
      info += `<div class="column filterinfoitem">Agente: ${
        this.brokersAutocomplete.find(
          (x) => x.value === this.tenantFilter.brokerId
        ).text
      }</div>`;
    }

    if (
      this.tenantFilter.tenantId !== "" &&
      this.tenantFilter.tenantId !== undefined
    ) {
      info += `<div class="column filterinfoitem">Cliente: ${
        this.tenantsAutocomplete.find(
          (x) => x.value === this.tenantFilter.tenantId
        ).text
      }</div>`;
    }

    if ((this.tenantFilter.dateFrom || this.tenantFilter.dateTo) !== null) {
      info += `<div class="column filterinfoitem">Fecha comprobante: `;
      if (this.tenantFilter.dateFrom !== null) {
        info += `desde: ${getDateFormatDDMMAAAA(
          this.tenantFilter.dateFrom.toString()
        )} `;
      }
      if (this.tenantFilter.dateTo !== null) {
        info += `hasta: ${getDateFormatDDMMAAAA(
          this.tenantFilter.dateTo.toString()
        )}`;
      }
      info += `</div>`;
    }
    if (info !== "") {
      info =
        '<div class="ui three column grid filterinfocontainer"><div class="row filterinforow">' +
        info +
        `</div></div>`;
    }
    return info;
  };

  @action getDetailedReportTenantByRangeDate = async (body) => {
    this.rootStore.buttonLoadingStore.changeState();

    return await agent.Report.getDetailedReportTenantByRangeDate(body);
  };
}
